import { actions as segmentioActions } from '@saucelabs/sl-util-segmentio';

export const EVENTS = Object.freeze({
  EXPIRED_PLAN_MODAL_DISMISSED: 'Expired Plan modal - Modal Dimissed',
  EXPIRED_PLAN_MODAL_FIND_PLAN: 'Expired Plan modal - Find plan',
  EXPIRED_PLAN_MODAL_REVIEW_TEST_RESULTS: 'Expired Plan modal - Review Test Results',
  ACCOUNT_EXPIRED_MODAL_SHOW: 'account-expired/show/modal',
});

export const trackEvent = segmentioActions.recordTrack;

export default trackEvent;
